'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  WHITE: 'WHITE',
  BLACK: 'BLACK'
};